class DeliveryCutoffTimer extends HTMLElement {
    connectedCallback() {
        const container = this;

        const availableProcessingDays = container.dataset.availableProcessingDays
           .split(',')
           .map(s => s.trim())
           .filter(Boolean)
           .map(Number);

        const availableShippingDays = container.dataset.availableShippingDays
           .split(',')
           .map(s => s.trim())
           .filter(Boolean)
           .map(Number);

        const cutoffHour = parseInt(container.dataset.cutoffHour, 10);
        const cutoffMinute = parseInt(container.dataset.cutoffMinute, 10);
        const processingDays = parseInt(container.dataset.processingDays, 10);
        const shippingDays = parseInt(container.dataset.shippingDays, 10);
        const template = container.dataset.messageTemplate;
        const storeTimeZone = container.dataset.storeTimezone || 'Europe/London';
        const enableDisplayThreshold = container.dataset.enableDisplayThreshold === 'true';
        const displayThresholdHours = parseInt(container.dataset.displayThresholdHours, 10);

        const outputEl = container.querySelector('[data-cutoff-output]');
        if (!outputEl) return;

        function getStoreNow() {
            const now = new Date();
            const formatter = new Intl.DateTimeFormat('en-GB', {
                timeZone: storeTimeZone,
                hour12: false,
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit'
            });

            const parts = formatter.formatToParts(now).reduce((acc, part) => {
                if (part.type !== 'literal') acc[part.type] = part.value;
                return acc;
            }, {});

            return new Date(`${parts.year}-${parts.month}-${parts.day}T${parts.hour}:${parts.minute}:${parts.second}`);
        }

        function isWorkingDay(date, workingDaysArray) {
            // If array is not provided or empty, assume all days are working days
            if (!Array.isArray(workingDaysArray) || workingDaysArray.length === 0) {
                return true;
            }
            return workingDaysArray.includes(date.getDay());
        }


        function getNextWorkingDay(date, workingDaysArray) {
            const d = new Date(date);

            // If no working days are defined, just return the next calendar day
            if (!Array.isArray(workingDaysArray) || workingDaysArray.length === 0) {
                d.setDate(d.getDate() + 1);
                return d;
            }

            do {
                d.setDate(d.getDate() + 1);
            } while (!isWorkingDay(d, workingDaysArray));
            return d;
        }

        function addWorkingDays(date, days, workingDaysArray) {
            let d = new Date(date);

            // If no working days are defined, treat all days as valid
            if (!Array.isArray(workingDaysArray) || workingDaysArray.length === 0) {
                d.setDate(d.getDate() + days);
                return d;
            }

            let added = 0;
            while (added < days) {
                d.setDate(d.getDate() + 1);
                if (isWorkingDay(d, workingDaysArray)) {
                    added++;
                }
            }
            return d;
        }

        function getOrdinalSuffix(day) {
            if (day > 3 && day < 21) return 'th';
            switch (day % 10) {
                case 1:  return 'st';
                case 2:  return 'nd';
                case 3:  return 'rd';
                default: return 'th';
            }
        }

        const now = getStoreNow();
        let dispatchDate = new Date(now);
        let cutoffTimeToday = new Date(dispatchDate);
        cutoffTimeToday.setHours(cutoffHour, cutoffMinute, 0, 0);

        const isTodayProcessingDay = isWorkingDay(now, availableProcessingDays);
            if (!isTodayProcessingDay || now > cutoffTimeToday) {
                dispatchDate = getNextWorkingDay(dispatchDate, availableProcessingDays);
            }

        const estimatedDispatchDate = addWorkingDays(dispatchDate, processingDays, availableProcessingDays);
        const deliveryDate = addWorkingDays(estimatedDispatchDate, shippingDays, availableShippingDays);

        let finalDispatchDeadline = new Date(estimatedDispatchDate);
        let processingDeadlineCounter = processingDays;
        while (processingDeadlineCounter > 0) {
            finalDispatchDeadline.setDate(finalDispatchDeadline.getDate() - 1);
            if (isWorkingDay(finalDispatchDeadline, availableProcessingDays)) {
                processingDeadlineCounter--;
            }
        }
        finalDispatchDeadline.setHours(cutoffHour, cutoffMinute, 0, 0);

        const timeDiffMs = finalDispatchDeadline - now;
        const totalHoursLeft = Math.floor(timeDiffMs / (60 * 60 * 1000));

        if (enableDisplayThreshold && totalHoursLeft > displayThresholdHours) {
            container.parentElement.style.display = 'none';
        } else {
            const totalMinutesLeft = Math.max(0, Math.floor(timeDiffMs / 60000));
            const days = Math.floor(totalMinutesLeft / (60 * 24));
            const hours = Math.floor((totalMinutesLeft % (60 * 24)) / 60);
            const minutes = totalMinutesLeft % 60;

            let timeLeftFormatted = '';
            if (days > 0) {
                timeLeftFormatted += `<span class="cutoff-timer__time-left">${days} day${days !== 1 ? 's' : ''} ${hours} hr${hours !== 1 ? 's' : ''} ${minutes} min${minutes !== 1 ? 's' : ''}</span>`;
            } else {
                timeLeftFormatted = `<span class="cutoff-timer__time-left">${hours} hr${hours !== 1 ? 's' : ''} ${minutes} min${minutes !== 1 ? 's' : ''}</span>`;
            }

            const day = deliveryDate.getDate();
const ordinal = getOrdinalSuffix(day);

const formattedDate = deliveryDate.toLocaleDateString('en-GB', {
    weekday: 'long',   // Friday
    day: 'numeric',    // 27
    month: 'long'      // March
});

const deliveryFormatted = `<span class="cutoff-timer__delivery-date">${formattedDate.replace(
    day,
    `${day}${ordinal}`
)}</span>`;

            const finalMessage = template
               .replace('[[time_left]]', timeLeftFormatted)
               .replace('[[delivery_day]]', deliveryFormatted);

            outputEl.innerHTML = finalMessage;
            container.style.display = '';
        }
    }
}

customElements.define('delivery-cutoff-timer', DeliveryCutoffTimer);